<template>
  <div class="ActivityType-list-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-dropdown
          id="dropdown-right dropdown-form"
          class="dropdown-form-filter"
          no-caret
          right
        >
          <template #button-content>
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </template>
          <h6 class="d-flex align-items-center mb-0 p-4">
            <span class="svg-icon mr-3">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </h6>
          <b-dropdown-divider> </b-dropdown-divider>
          <b-dropdown-form>
            <b-container class="p-0">
              <b-row>
                <b-col cols="3">
                  <basic-input
                    label="Mã"
                    placeholder="Nhập mã"
                    name="Mã"
                    :value.sync="filter.code"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="3">
                  <basic-select
                    label="Trạng thái"
                    placeholder="Chọn trạng thái"
                    name="status"
                    :options="status"
                    :value.sync="filter.status"
                    track-by="value"
                    value-label="text"
                    data-vv-as="Trạng thái"
                  ></basic-select>
                </b-col>
                <b-col cols="3">
                  <basic-input
                    label="Loại hoạt động"
                    placeholder="Nhập loại hoạt động"
                    name="Loại hoạt động"
                    :value.sync="filter.name"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="3">
                  <basic-input
                    label="Thứ tự hiển thị"
                    placeholder="Nhập thứ tự hiển thị"
                    name="Thứ tự hiển thị"
                    :value.sync="filter.displayIndex"
                  >
                  </basic-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <basic-input
                    label="Ghi chú"
                    placeholder="Nhập ghi chú"
                    name="Ghi chú"
                    :value.sync="filter.note"
                  >
                  </basic-input>
                </b-col>
              </b-row>
            </b-container>
          </b-dropdown-form>
          <b-dropdown-divider> </b-dropdown-divider>
          <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
            <b-button
              class="btn ml-2"
              href="#"
              tabindex="0"
              @click="resetRequest"
            >
              <span class="svg-icon">
                <inline-svg
                  src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                />
              </span>
              Reset bộ lọc
            </b-button>
            <b-button
              class="btn ml-2"
              href="#"
              tabindex="0"
              @click="searchRequest"
            >
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
              </span>
              Lọc dữ liệu
            </b-button>
          </div>
        </b-dropdown>
        <b-button
          v-if="isInsertPermission"
          class="btn btn-success ml-2"
          type="button"
          @click="createItem"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
          </span>
          Thêm mới
        </b-button>
        <b-button
          v-if="isInsertPermission"
          class="btn btn-success ml-2"
          type="button"
          @click="importItems"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/upload-cloud.svg" />
          </span>
          Import
        </b-button>
        <modal-import @import-success="loadData(true)" />
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="ActivityType-list-page__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="column"
                  :data="data"
                  :paging="paging"
                  :tableAction="false"
                  :selectAction="false"
                  :searchAction="false"
                  @search="searchRequest"
                  @reset="resetRequest"
                  @sortBy="sortRequest"
                >
                  <template v-slot:body="{ item }">
                    <td :class="getPositionClass(item.code)">
                      {{ item.code }}
                    </td>
                    <td :class="getPositionClass(item.name)">
                      {{ item.name }}
                    </td>
                    <td
                      class="text-center"
                      :class="getPositionClass(item.displayIndex)"
                    >
                      {{ item.displayIndex }}
                    </td>
                    <td :class="getPositionClass(item.note)">
                      {{ item.note }}
                    </td>
                    <td class="status">
                      <div class="status" :class="getStatus(item.status)">
                        {{
                          item.status == 0
                            ? 'Hoạt động'
                            : item.status == 1
                            ? 'Không hoạt động'
                            : 'Nháp'
                        }}
                      </div>
                    </td>
                    <td style="width: 20px">
                      <action-dropdown
                        :value="item"
                        :show_edit="isUpdatePermission"
                        :show_delete="false"
                        :show_copy="false"
                        :boundary="data.length > 2 ? 'scrollParent' : 'window'"
                        @view="viewItem"
                        @edit="editItem"
                        @copy="copyItem"
                      >
                        <b-dropdown-text
                          v-if="isDeletePermission"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="deleteItem(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm"
                              :class="
                                item.status == 0
                                  ? 'text-danger'
                                  : 'text-primary'
                              "
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/power.svg"
                              />
                            </span>
                            <span
                              class="success navi-text"
                              :class="
                                item.status == 0
                                  ? 'text-danger'
                                  : 'text-primary'
                              "
                            >
                              {{
                                item.status == 0
                                  ? 'Không hoạt động'
                                  : 'Hoạt động'
                              }}
                            </span>
                          </a>
                        </b-dropdown-text>
                      </action-dropdown>
                    </td>
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { TAG_TYPE } from '../../../core/plugins/constants';
export default {
  props: {},
  name: 'ActivityTypeList',
  components: {
    'modal-import': () => import('./components/FormActivityTypeImport.vue'),
  },
  data() {
    return {
      status: [
        {
          value: 0,
          text: 'Hoạt động',
        },
        {
          value: 1,
          text: 'Không hoạt động',
        },
        {
          value: 2,
          text: 'Nháp',
        },
      ],
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      filter: {
        code: null,
        status: null,
        name: null,
        displayIndex: null,
        note: null,
      },
      sort: {
        by: 'DisplayIndex',
        order: 'asc',
      },
      column: [
        {
          key: 'code',
          label: 'Mã',
          sortable: false,
        },
        {
          key: 'name',
          label: 'Tên loại hoạt động',
          sortable: false,
        },
        {
          key: 'displayIndex',
          label: 'Thứ tự hiển thị',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'note',
          label: 'Ghi chú',
          sortable: false,
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          class: 'text-center',
        },
        {
          key: '',
          label: '',
          sortable: false,
        },
      ],
      data: [],
      loading: false,
      selectedItems: [],
    };
  },
  computed: {
    searchParams() {
      const payload = this.removeEmpty({
        code: this.filter.code,
        status: this.filter.status,
        name: this.filter.name,
        displayIndex: this.filter.displayIndex,
        note: this.filter.note,
        page: this.paging.page,
        size: this.paging.pageSize,
        sortBy: this.sort.by,
        sortOrder: this.sort.order,
      });
      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }
      return params;
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
  },
  methods: {
    searchRequest() {
      this.loadData();
      document.body.click();
    },
    resetRequest() {
      this.filter.code = null;
      this.filter.status = null;
      this.filter.name = null;
      this.filter.displayIndex = null;
      this.filter.note = null;
      this.loadData();
      document.body.click();
    },
    sortRequest(sortData) {
      if (this.sort.by === sortData.column) {
        this.sort.order = this.sort.order === 'asc' ? 'desc' : 'asc';
      } else {
        this.sort.by = sortData.column;
        this.sort.order = 'asc';
      }
      this.loadData();
    },
    viewItem(item) {
      this.$router.push({
        name: 'activity_type_view',
        params: {
          id: item.id,
        },
      });
    },
    deleteItem(item) {
      let btn = item.status == 0 ? 'btn-active' : 'btn-inactive';
      let textStatusB = item.status ? 'Hoạt động' : 'Không hoạt động';
      let textStatusA = !item.status ? 'Hoạt động' : 'Không hoạt động';
      this.$swal({
        title: '',
        text: `Bạn có chắc chắn muốn chuyển trạng thái ${textStatusA} thành ${textStatusB} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Hủy',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: 'Chắc chắn',
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.changeStatus(item);
          }
        }.bind(this),
      );
    },
    // TODO: Lanh - If want to new sreen for insert
    // createItem() {
    //   this.$router.push({
    //     name: 'activity_type_create',
    //   });
    // },
    editItem(item) {
      this.$router.push({
        name: 'activity_type_edit',
        params: {
          id: item.id,
          form_type: 'edit',
        },
      });
    },

    getPositionClass(value) {
      if (typeof value === 'number' && !isNaN(value)) {
        return 'text-right';
      } else if (typeof value === 'string') {
        return 'text-left';
      } else if (
        (Object.prototype.toString.call(value) === '[object Date]' &&
          !isNaN(value)) ||
        !isNaN(Date.parse(value))
      ) {
        return 'text-center';
      } else {
        return 'text-right';
      }
    },
    createItem() {
      this.$router.push({
        name: 'activity_type_edit',
        params: {
          form_type: 'create',
        },
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        this.veeFields[ref].dirty &&
        this.veeFields[ref].validated
      ) {
        return this.veeFields[ref].valid;
      }
      return null;
    },
    importItems() {
      this.$bvModal.show('modal-import');
    },

    async changeStatus(item) {
      this.$store.commit('context/setLoading', true);
      try {
        const formData = new FormData();
        formData.append('id', item.id);
        formData.append('status', item.status ? 0 : 1);
        formData.append('code', item.code || '');
        formData.append('name', item.name || '');
        formData.append(
          'displayIndex',
          item.displayIndex !== null ? item.displayIndex : 0,
        );
        formData.append('note', item.note || '');
        formData.append('preDetailLink', item.preDetailLink || '');
        formData.append('preRedirectLink', item.preRedirectLink || '');
        formData.append('preLevel', item.preLevel || '');
        formData.append(
          'preReminderNumber',
          item.preReminderNumber !== null ? item.preReminderNumber : 1,
        );
        formData.append(
          'preReminderContain',
          item.preReminderContain !== null
            ? item.preReminderContain
            : JSON.stringify([{ date: '', time: '', content: '' }]),
        );

        const res = await this.$api.put(`/ActivityType/${item.id}`, formData);
        const { error } = res;
        if (error) {
          this.$toastr.e({
            title: 'Lỗi!',
            msg: error.message,
          });
          return;
        }
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Cập nhật trạng thái thành công',
        });
        this.loadData();
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error.message || 'Cập nhật trạng thái thất bại',
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    async loadData() {
      try {
        this.$store.commit('context/setLoading', true);
        const { data } = await this.$api.get('ActivityType', {
          params: this.searchParams,
        });
        this.data =
          data.items.map((el) => {
            return {
              ...el,
            };
          }) || [];
        this.paging.total = data.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    getDataHospital(tags) {
      if (!tags || !tags.length) return null;
      const agencies = tags.filter((el) => el.tag.type === TAG_TYPE.AGENCY);
      return agencies.map((el) => el.tag.name).join(', ');
    },
    getStatus(status) {
      if (status === 0) return 'active';
      if (status === 1) return 'inactive';
      return 'draft';
    },
    getStatusText(status) {
      if (status === 0) return 'Active';
      if (status === 1) return 'Inactive';
      return 'Draft';
    },
    searchDebounce(value) {
      this.filter.searchText = value;
      this.resetPaging();
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },
    getSearchDataPrepare() {
      this.$api.get('ActivityType/PrepareSearchFormItem').catch((error) => {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      });
    },
  },
  async created() {
    await Promise.all([this.loadData(), this.getSearchDataPrepare()]);
  },
};
</script>
<style lang="scss" scoped>
.status {
  padding: 6px 24px;
  color: #fff;
  text-transform: capitalize;
  width: 160px;
  text-align: center;

  &.active {
    background: #21a567;
    border-radius: 20px;
  }

  &.inactive {
    background: #ff5756;
    border-radius: 20px;
  }

  &.draft {
    background: #888c9f;
    border-radius: 20px;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 850px;
    }
  }
}

.search-input {
  min-width: 220px;
}
</style>
